










import Vue from 'vue';

export default Vue.extend({
    props: ['toolGroupData'],
    data() {
        return {
        };
    },
    methods: {
        handClick(item) {
            this.$emit('selectTool', item);
        },
    },
});
